import React from "react";

import { Tooltip, TooltipProps, tooltipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

import { COLOR_WHITE } from "~/theme/colors";

export const TooltipStyled = styled(
  ({ className, children, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }}>
      {children}
    </Tooltip>
  ),
)(({ theme }) => {
  return {
    [`& .${tooltipClasses.tooltipArrow}`]: {
      padding: theme.spacing(2),
      ...theme.typography.body2,
      background: COLOR_WHITE,
      borderRadius: 0,
      color: theme.palette.common.black,
      boxShadow: `0px 4px 16px 0px rgba(0, 0, 0, 0.15)`,
    },
    [`& .${tooltipClasses.arrow}`]: {
      "&::before": {
        background: COLOR_WHITE,
      },
    },
  };
});
